import { GetLoadables } from '../loader';
let exported = [
    'THREE',
    'D3FORCE'
];
let loader = ()=>null;
// #if process.env.UIX_CHUNKED === 'true'
loader = ()=>{
    return import(/* webpackChunkName: 'rforce' */ './rforceLoad');
};
const L = GetLoadables(loader, [
    'ForceGraph2D',
    'ForceGraph3D'
]);
// #endif
// #if process.env.UIX_CHUNKED === 'false'
// import * as L from './rforceLoad'
// #endif
export const { ForceGraph2D, ForceGraph3D } = L;
export const exportedThree = {
    names: exported,
    loader
};
